import { GetAgenticLogicRuleGeneratedTestsResponseBodyType } from "@intelligems/ig-types/functions/agentic-logic/draft/generated-tests";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const getAgenticLogicRuleGeneratedTests = async (ruleId: string) => {
  const resp = await api.get<GetAgenticLogicRuleGeneratedTestsResponseBodyType>(
    `/v2/agentic-logic/rules/${ruleId}/generated-tests`
  );
  return resp.data;
};

/**
 * The draft's AI-generated suite with the position of every test in it, for
 * the Advanced editor's read-only test file. `suite` is `null` until a test
 * run has generated one.
 *
 * Invalidated wherever the draft's suite can move: a draft save, a version
 * import, the end of a test run (the generation gate writes the suite back),
 * and an adoption (which seeds it from its response instead).
 */
export const useAgenticLogicRuleGeneratedTests = (
  ruleId: string | undefined
) => {
  return useQuery<GetAgenticLogicRuleGeneratedTestsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.generatedTests(ruleId!),
    queryFn: async () => getAgenticLogicRuleGeneratedTests(ruleId!),
    enabled: !!ruleId,
  });
};
